import { defineMessages } from 'react-intl'


export default defineMessages({
  goHome: {
    id: 'button.go-home',
    defaultMessage: 'Go Home',
  },
})
